<div class="login-page landing-login">
  <div class="container">
    <div class="login-hero">
      <div class="hero-left">
        <h1 class="hero-title">Bienvenido a <span class="brand">PanaKYC</span></h1>
        <p class="hero-subtitle">
          Plataforma segura y moderna para la gestión de KYC y cumplimiento.
        </p>
        <p class="hero-description">
          Acceda para gestionar clientes, verificar empresas y ejecutar evaluaciones de riesgo.
        </p>
      </div>

      <div class="hero-right">
        <div class="login-card">
          <form
            class="login-form"
            (submit)="submit(); $event.preventDefault()"
            novalidate
            aria-labelledby="login-title"
          >
            <h2 id="login-title">Iniciar sesión</h2>

            <label for="email">Correo</label>
            <input
              id="email"
              name="email"
              type="email"
              autocomplete="email"
              [value]="email()"
              (input)="email.set($any($event.target).value)"
              required
              aria-describedby="email-error"
              [attr.aria-invalid]="emailError() ? 'true' : null"
            />
            <div id="email-error" class="error" role="alert" *ngIf="emailError()">
              {{ emailError() }}
            </div>

            <label for="password">Contraseña</label>
            <input
              id="password"
              name="password"
              type="password"
              autocomplete="current-password"
              [value]="password()"
              (input)="password.set($any($event.target).value)"
              required
              aria-describedby="password-error"
              [attr.aria-invalid]="passwordError() ? 'true' : null"
            />
            <div id="password-error" class="error" role="alert" *ngIf="passwordError()">
              {{ passwordError() }}
            </div>

            <div class="login-aux">
              <label class="remember"
                ><input
                  id="remember"
                  type="checkbox"
                  (change)="remember.set($any($event.target).checked)"
                  [checked]="remember()"
                  aria-label="Mantener sesión iniciada"
                />
                Recuérdame</label
              >
              <a routerLink="/forgot-password">¿Olvidó su contraseña?</a>
            </div>

            <div class="login-actions">
              <a routerLink="/" class="btn btn-secondary" role="button" aria-label="Volver"
                >Volver</a
              >
              <button
                class="btn btn-primary"
                type="submit"
                [attr.disabled]="submitting() ? true : null"
              >
                Entrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
